<template>
  <div />
</template>

<script>

/**
 * Vue: Overlay drag (overlay-drag)
 * -----------------------------------------------------------------------------
 * Add handle to overlays that can be dragged to close the overlay.
 *
 */
import { mapActions } from 'vuex'
import { Drag } from './drag-api'

export default {
  name: 'OverlayDrag',

  data() {
    return {
      overlayElement: false,
      namespace: false,
      overlayDrag: false,
      dragHandlers: false,
      dragCloseThreshold: 120,
      shouldScroll: false,
    }
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
     * Start dragging object
     */
    initiateDragClose(overlayElement, namespace) {
      this.overlayElement = overlayElement
      this.namespace = namespace
      this.overlayDrag = new Drag({ offset: 3 })
      this.dragCloseThreshold = overlayElement.offsetHeight / 9
    },

    /**
     * Touch start on the overlay
     * @param event
     */
    started(event) {
      this.overlayDrag?.touchStart(event)
    },

    /**
     * Assigns commands to onDown and onUp event of the drag constructor
     *
     * @param {Object} event - event object
     */
    dragMoved(event, positionReach) {
      if (!this.overlayDrag) {
        return
      }

      const movement = this.overlayDrag.upMoveStep(event)

      if (this.shouldScroll) {
        this.overlayElement.style.transform = `translateY(${movement}px)`
      }

      this.overlayDrag.touchMove(event, {
        onDown: () => {
          if ((!this.overlayElement || !positionReach.top) && !this.shouldScroll) {
            this.shouldScroll = false

            return
          }

          this.shouldScroll = true

          if (movement > this.dragCloseThreshold) {
            this.overlayDrag.setDragShouldClose(true)
          }
        },

        onUp: () => {
          if ((!this.overlayElement || !positionReach.bottom) && !this.shouldScroll) {
            this.shouldScroll = false

            return
          }

          this.shouldScroll = true
          this.overlayDrag.setDragShouldClose(false)
        },
      })
    },

    /**
      * - Calls drag constructor touchEnd event
      * - In case of drag surpassing closing threshold closes overlay
      *  and resets values
      *
      * @param {Object} event - event object
      */
    async dragEnded(event) {
      if (!this.overlayDrag || !this.shouldScroll) {
        return
      }

      this.shouldScroll = false
      if (this.overlayDrag.dragShouldClose) {
        this.closeOverlay(this.namespace)
        await cnvs.Sleep(this.$timing('normal'))
      }
      this.resetOverlayDragProps(event)
    },

    /**
      * Reset overlay dragging values
      */
    async resetOverlayDragProps(event) {
      await this.$nextTick()
      this.overlayElement.style.transform = `translateY(${0}px)`
      this.overlayDrag.setDragShouldClose(false)
      this.overlayDrag.touchEnd(event)
    },
  },

}
</script>
